import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IAiRelatedInformationService = ( createDecorator('IAiRelatedInformationService'));
export { IAiRelatedInformationService };
